/**
 * @description validate phone number. Valid phone is +1 (234) 567-89-01
 *
 * @param {string} phone phone number as string
 *
 * @returns {boolean} true if valid
 */
export function checkPhone(phone) {
  const regexp = new RegExp(/^\+\d \(\d{3}\) \d{3}-\d{2}-\d{2}/);
  return regexp.test(phone) && phone !== '';
}

/**
 * @description validate phone number. Valid phone is +7 (123) 456-78-90 or
 * with more then 5 digits
 *
 * @param {string} phone phone number as string
 *
 * @returns {boolean} true if valid
 */
export function checkMultiregionalPhone(phone) {
  const rusMask = new RegExp(/^\+\d \(\d{3}\) \d{3}-\d{2}-\d{2}/);
  const rusCode = '+7';

  switch (true) {
    case phone?.includes(rusCode):
      return rusMask.test(phone);
    default:
      return phone.replace(/[+\s]/g, '').length > 5;
  }
}

/**
 * @description validate passport number. Valid number is '1234 123456'
 *
 * @param {string} passport passport number as string
 *
 * @returns {boolean} true if valid
 */
export function checkPassport(passport) {
  const regexp = new RegExp(/^\d{4} \d{6}$/);
  return regexp.test(passport) && passport !== '';
}

/**
 * @description validate date. Valid date is '30.12.2019'
 *
 * @param {string} date date as string DD.MM.YYYY
 *
 * @returns {boolean} true if valid
 */
export function checkDate(date) {
  const regexp = new RegExp(/^\d{2}.\d{2}.\d{4}$/);
  return regexp.test(date) && date !== '';
}

/**
 * @description validate name. Valid if only chars and spaces included
 *
 * @param {string} name as string
 *
 * @returns {boolean} true if valid
 */
export function checkName(name) {
  const regexp = new RegExp(/[^a-zA-Zа-яА-ЯёЁ\s]+/);
  return Boolean(name && !regexp.test(name) && name !== '');
}

/**
 * @description validate email. Check by pattern "anything" "@" "anything" "." "anything"
 *
 * @param {string} email phone number as string
 *
 * @returns {boolean} true if valid
 */
export function checkEmail(email) {
  const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  return Boolean(regexp.test(email) && email !== '');
}

/**
 * @description validate string not empty.
 *
 * @param {string} string
 *
 * @returns {boolean} true if valid
 */
export function checkNotEmpty(string) {
  return Boolean(string && String(string)?.trim() !== '');
}

/**
 * @description validate string to contains only numbers.
 *
 * @param {string} string
 *
 * @returns {boolean} true if valid
 */
export function checkNumbers(string) {
  return Boolean(string.trim() !== '' && !isNaN(string));
}

/**
 * @description validate string as password. Only length >= 6 is valid pass
 *
 * @param {string} string
 *
 * @returns {boolean} true if valid
 */
export function checkPassword(string) {
  return string.trim() !== '' && string.length >= 6;
}

/**
 * @description search and checks all fields wich ends on *Valid.
 *
 * @param {object} obj object to be reseted
 *
 * @returns {boolean} true if all fields === true
 */
export function checkAllKeys(obj) {
  return Object.keys(obj).every(key => {
    return !(key.match(/Valid$/) != null && obj[key] === false);
  });
}

/**
 * @description search all fields wich ends on *Valid and set it to 'true'. Checks only boolean fields.
 *
 * @param {object} obj object to be reseted
 *
 * @returns nothing, mutate input
 */
export function resetValidFieldsInObject(obj) {
  Object.keys(obj).forEach(key => {
    if (key.match(/Valid$/) != null && typeof obj[key] === 'boolean') {
      // eslint-disable-next-line
      obj[key] = true;
    }
  });
}
